import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import noop from 'lodash/noop';

import themeable from 'zignal-landscape/lib/themeable';

export const ForgotForm = ({
  styles,
  formTitle,
  handleSubmit,
  message,
  logoSrc,
  hasError = false
}) => {
  return (
    <form className={styles.background} onSubmit={handleSubmit} >
      <Link to="/login">
        <img className={styles.logo} src={logoSrc} />
      </Link>
      <h4 className={styles.title}>{formTitle}</h4>
      <label>
        <span className={styles.emailLabel}>Email:</span>
        <Field
          component="input"
          className={styles.emailAddress}
          name="email"
          type="email"
          onChange={noop}
          required
        />
      </label>
      {message ?
        <p className={hasError ? styles.errorMessage : styles.successMessage}>
          {message}
        </p>
        : null
      }
      <Link className={styles.forgotPasswordLink} to="/forgot/password" >
        Forgot Password?
      </Link>
      <Link className={styles.forgotUsernameLink} to="/forgot/username" >
        Forgot Username?
      </Link>
      <button type="submit" className={styles.btn}>Send Email</button>
    </form>
  );
};

ForgotForm.propTypes = {
  styles: PropTypes.object,
  formTitle: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  message: PropTypes.string,
  hasError: PropTypes.bool,
  logoSrc: PropTypes.string.isRequired
};

export default reduxForm({
  form: 'ForgotForm'
})(themeable(ForgotForm));
